import { createApp } from 'vue'
import ArticleCard from '~/js/components/articleCard'
import FTab from '~/js/components/tab'
import { getUrlWithQueryParams } from '~/js/helpers/url-helper'
import { Article, CATEGORIES, CATEGORY_MAP } from '~/js/models/article'
import { baseUrlFrontApi } from '~/js/templates/index/helpers'
import { getQueryParams } from '~/js/helpers/url-helper'

const ID = 'js-blog'
const defaultPageInfo = {
  endCursor: '',
  hasNextPage: false,
  hasPreviousPage: false,
  startCursor: '',
}

document.addEventListener('DOMContentLoaded', () => {
  const element = document.getElementById(ID)
  if (!element) return

  const noImageUrl = element.dataset.noImageUrl
  const tabItemTitles = ['ALL', ...CATEGORIES]
  const tabItems = tabItemTitles.map((tabItem) => {
    return { title: tabItem.toUpperCase(), isSelected: false }
  })
  const limit = element.dataset.itemsPerPage

  const after = new URLSearchParams(location.search).get('after')
  const before = new URLSearchParams(location.search).get('before')

  const categoryParam =
    new URLSearchParams(location.search).get('category') || ''
  const isCategoryParamTag =
    CATEGORIES.map((category) => category.toUpperCase()).indexOf(
      categoryParam.toUpperCase()
    ) > -1
  let selectedIndex = undefined
  if (isCategoryParamTag) {
    selectedIndex = tabItemTitles
      .map((title) => title.toUpperCase())
      .indexOf(categoryParam.toUpperCase())
  } else {
    const selectedCategory = CATEGORY_MAP.find((category) => {
      return category.id === categoryParam
    })
    const categoryLabel = selectedCategory && selectedCategory.label
    const categoryIndex = tabItemTitles.indexOf(categoryLabel)
    selectedIndex = categoryIndex > -1 ? categoryIndex : 0
  }

  createApp({
    name: 'TemplatesBlog',
    components: {
      ArticleCard,
      FTab,
    },
    data() {
      return {
        articleItems: [],
        max: 0,
        selectedIndex,
        tabItems,
        pageInfo: defaultPageInfo,
        before,
        after,
      }
    },
    created() {
      this.setSelectedTabItem()
      this.fetchArticles()
    },
    methods: {
      scrollTop() {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        })
      },

      onTagClicked(tag) {
        const categoryIndex = tabItemTitles
          .map((title) => title.toUpperCase())
          .indexOf(tag.toUpperCase())
        const index = categoryIndex > -1 ? categoryIndex : 0
        this.setConditions({ index })
        this.scrollTop()
      },

      onTabItemClicked(index) {
        this.setConditions({ index })
      },

      fetchArticles() {
        this.articleItems = []
        this.pageInfo = defaultPageInfo
        const queryParams = getQueryParams({
          limit,
          tag: tabItemTitles[this.selectedIndex],
          before: this.before || undefined,
          after: this.after || undefined,
        })

        fetch(`${baseUrlFrontApi}/contents/news/list?${queryParams}`, {
          method: 'GET',
        })
          .then((response) => response.json())
          .then((data) => {
            this.pageInfo = data.pageInfo
            this.articleItems = data.articles.map(
              (article) =>
                new Article({
                  ...article,
                  published_at: article.publishedAt,
                  image: article.image ? article.image.url : noImageUrl,
                })
            )
          })
      },

      next() {
        if (!this.pageInfo.hasNextPage) return
        this.setConditions({
          after: this.pageInfo.endCursor,
          index: this.selectedIndex,
        })
        this.scrollTop()
      },

      prev() {
        if (!this.pageInfo.hasPreviousPage) return
        this.setConditions({
          before: this.pageInfo.startCursor,
          index: this.selectedIndex,
        })
        this.scrollTop()
      },

      setConditions({ index, before, after }) {
        this.before = before
        this.after = after
        this.selectedIndex = index || 0
        this.setSelectedTabItem()
        this.fetchArticles()
        const category =
          this.selectedIndex > 0
            ? Object.values(CATEGORY_MAP)[this.selectedIndex].id
            : undefined
        history.pushState(
          null,
          null,
          getUrlWithQueryParams({
            category,
            before,
            after,
          })
        )
        window.dispatchEvent(new Event('popstate'))
      },

      setSelectedTabItem() {
        this.tabItems.forEach((item, index) => {
          item.isSelected = index === this.selectedIndex
        })
      },
    },
  }).mount(element)
})
